// Shared motion language — TECHNICAL. SUBTLE. PURPOSEFUL.
export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = (delay = 0, y = 28) => ({
    initial: { opacity: 0, y },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
    transition: { duration: 0.8, delay, ease: EASE },
});

export const lineMask = (delay = 0) => ({
    initial: { y: "112%" },
    animate: { y: "0%" },
    transition: { duration: 1.05, delay, ease: EASE },
});
